import React from "react";
import { H2, Text, CBanner, CFontIcon } from "@appcues/component-library";

const DashboardOverview = ({ header }) => (
  <React.Fragment>
    <H2 type="secondary">{header}</H2>
    <CBanner type="positive" marginY={12}>
      <CFontIcon
        className="fas fa-check-circle"
        altText="Success"
        color="$green-dark"
        marginRight={14}
      />
      <Text>Appcues is installed</Text>
    </CBanner>
  </React.Fragment>
);

export default DashboardOverview;
